import VueI18n from 'vue-i18n';
import Vue from 'vue';

Vue.use(VueI18n);

// Get the default locale from localStorage or fallback to 'nl'
const i18n = new VueI18n({
    locale: 'nl', // Set the default locale
    messages: window.locales, // Assuming this is populated globally with your language files
});

export default i18n;
